import { clsx } from 'clsx'

interface Props {
	class?: string
}

const LoadingIcon = (props: Props) => (
	<svg
		class={clsx('animate-spin', props.class)}
		fill='currentColor'
		height='20'
		viewBox='0 0 20 20'
		width='20'
		xmlns='http://www.w3.org/2000/svg'
	>
		<g clip-path='url(#clip0_4790_2661)'>
			<path d='M10 20C8.65039 20 7.33984 19.7363 6.10742 19.2148C4.91602 18.7109 3.84766 17.9883 2.92969 17.0703C2.01172 16.1523 1.28906 15.084 0.785156 13.8926C0.263672 12.6602 0 11.3496 0 10C0 9.61133 0.314453 9.29688 0.703125 9.29688C1.0918 9.29688 1.40625 9.61133 1.40625 10C1.40625 11.1602 1.63281 12.2852 2.08203 13.3457C2.51563 14.3691 3.13477 15.2891 3.92383 16.0781C4.71289 16.8672 5.63281 17.4883 6.65625 17.9199C7.71484 18.3672 8.83984 18.5938 10 18.5938C11.1602 18.5938 12.2852 18.3672 13.3457 17.918C14.3691 17.4844 15.2891 16.8652 16.0781 16.0762C16.8672 15.2871 17.4883 14.3672 17.9199 13.3438C18.3672 12.2852 18.5938 11.1602 18.5938 10C18.5938 8.83984 18.3672 7.71484 17.918 6.6543C17.4858 5.63332 16.8604 4.70549 16.0762 3.92188C15.2934 3.13656 14.3654 2.51101 13.3438 2.08008C12.2852 1.63281 11.1602 1.40625 10 1.40625C9.61133 1.40625 9.29688 1.0918 9.29688 0.703125C9.29688 0.314453 9.61133 0 10 0C11.3496 0 12.6602 0.263672 13.8926 0.785156C15.084 1.28906 16.1523 2.01172 17.0703 2.92969C17.9883 3.84766 18.709 4.91797 19.2129 6.10742C19.7344 7.33984 19.998 8.65039 19.998 10C19.998 11.3496 19.7344 12.6602 19.2129 13.8926C18.7109 15.084 17.9883 16.1523 17.0703 17.0703C16.1523 17.9883 15.082 18.709 13.8926 19.2129C12.6602 19.7363 11.3496 20 10 20Z' />
		</g>
		<defs>
			<clipPath id='clip0_4790_2661'>
				<rect fill='white' height='20' width='20' />
			</clipPath>
		</defs>
	</svg>
)

export { LoadingIcon }
